export default class SearchRouteParameters {
  /** @param {Object} data
   * @param {RouteRequest} data.routeRequest
   * @param data.restrictions
   * @param {City[]} data.excludedCities
   * @param {Country[]} data.excludedCountries
   * @param data.mapBounds
   * @param data.routeId 
   */
  constructor({ routeRequest, restrictions, excludedCities, excludedCountries, mapBounds, routeId }) {
    /** @type {RouteRequest} */
    this.routeRequest = routeRequest;
    this.restrictions = restrictions;
    /** @type {City[]} */
    this.excludedCities = excludedCities;
    /** @type {Country[]} */
    this.excludedCountries = excludedCountries;
    this.mapBounds = mapBounds;
    this.routeId = routeId;
  }
}
